import { render, staticRenderFns } from "./test.vue?vue&type=template&id=54586d22"
import script from "./test.vue?vue&type=script&lang=ts"
export * from "./test.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports